import React from 'react';
import PropTypes from "prop-types";
import {useSearchParams} from "react-router-dom";

import ColumnSelector from './ColumnSelector';
import ExpressionSelector from './ExpressionSelector';
import Input from "./Input";
import {catchQueryFilters} from "./filters_utils";

const Filter = function (
    {
        index,
        filter,
        columns,
        selectedColumns,
        query_divider = '~'
    }
) {
    const [searchParams, setSearchParams] = useSearchParams();

    return (
        <div className='filter'>
            <ColumnSelector
                columns={columns}
                index={index}
                column_key={filter.column}
                selectedColumns={selectedColumns}
                query_divider={query_divider}
            />
            <ExpressionSelector
                index={index}
                filter={filter}
                columns={columns}
                query_divider={query_divider}
            />
            <Input
                filter={filter}
                columns={columns}
                index={index}
                query_divider={query_divider}
            />
            <button onClick={() => {
                const filters_x = JSON.parse(JSON.stringify(catchQueryFilters()));
                const searchParamsNew = new URLSearchParams();
                filters_x.splice(index, 1);
                filters_x.map((filter_x, i) => {
                    if (filter_x.hasOwnProperty('column') && filter_x.column && filter_x.hasOwnProperty('expression') && filter_x.expression && filter_x.hasOwnProperty('value')) {
                        searchParamsNew.set('column' + query_divider + i, filter_x.column);
                        searchParamsNew.set('expression' + query_divider + i, filter_x.expression);
                        searchParamsNew.set('value' + query_divider + i, filter_x.value);
                    } else {
                        Object.keys(filter_x).map(key => {
                            searchParamsNew.set(key, filter_x[key]);
                        })
                    }
                });
                setSearchParams(searchParamsNew);
            }} className='remove-filter-button'>
                <i className="fas fa-trash"/>
            </button>
        </div>
    );
}

Filter.propTypes = {
    index: PropTypes.number.isRequired,
    filter: PropTypes.shape({
        column: PropTypes.string.isRequired,
        expression: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired,
    }).isRequired,
    columns: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        expressions: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
        multiple: PropTypes.bool,
        default: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        component: PropTypes.func
    })).isRequired,
    selectedColumns: PropTypes.arrayOf(PropTypes.string).isRequired,
    query_divider: PropTypes.string
};

export default Filter;
